import { AxiosResponse } from 'axios';

import { handleApiError, nodeApi, phpApi } from '../../../api';
import { ApiResolve } from '../../../types/api';
import { BannersData, DashboardData } from '../dashboardV2.types';

export const getInitialData: () => Promise<DashboardData> = (): Promise<DashboardData> => new Promise(
  (resolve: ApiResolve<DashboardData>): Promise<void | never[]> => (
    phpApi.get('/api/dashboard')
      .then((response: AxiosResponse<DashboardData>): void => resolve(response.data))
      .catch(handleApiError)
  )
);

export const getBanners: () => Promise<BannersData> = (): Promise<BannersData> => new Promise(
  (resolve: ApiResolve<BannersData>): Promise<void | never[]> => (
    nodeApi.get('/banners')
      .then((response: AxiosResponse<BannersData>): void => resolve(response.data))
      .catch(handleApiError)
  )
);
